import React, { Component as C } from "react"
import PerfectScrollbar from "perfect-scrollbar"
import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
import { selectionTypes } from "@cirrus/legacy/app-common/enums/selection-types.es6"
import StatelessCheckbox from "@cirrus/legacy/app-components/form-controls/checkboxes/stateless-checkbox/index.jsx"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./items.less"

class LabelsFilterItems extends C {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    onItemValueChanged: PropTypes.func,
    hideEmptyHint: PropTypes.bool,
    onDeleteItem: PropTypes.func,
    dataQa: PropTypes.string,
  }

  perfectScrollbar = null

  constructor(props) {
    super(props)

    this._setLabelList = this.setLabelList.bind(this)
  }

  componentDidMount() {
    if (this._labelList == null) {
      return
    }

    this.perfectScrollbar = new PerfectScrollbar(this._labelList, this.getScrollbarOptions())
  }

  componentDidUpdate() {
    if (this._labelList == null) {
      return
    }

    if (this.perfectScrollbar) {
      this.perfectScrollbar.update()
    } else {
      this.perfectScrollbar = new PerfectScrollbar(this._labelList, this.getScrollbarOptions())
    }
  }

  componentWillUnmount() {
    if (this.perfectScrollbar && this._labelList != null) {
      this.perfectScrollbar.destroy()
    }

    this.perfectScrollbar = null
  }

  getScrollbarOptions() {
    return {
      wheelPropagation: false,
    }
  }

  setLabelList(element) {
    if (this.perfectScrollbar && this._labelList != null) {
      this.perfectScrollbar.destroy()
    }

    this.perfectScrollbar = null
    this._labelList = element
  }

  render() {
    let { items, onItemValueChanged, hideEmptyHint, onDeleteItem, dataQa } = this.props

    return (
      <div ref={this._setLabelList} className={classnames(styles.labelList, this.props.className)}>
        <div data-qa={dataQa}>
          {!!items.length &&
            items.map((i, index) => {
              return (
                <div key={i.id} className={styles.listItem}>
                  {i.selectedType !== undefined ? (
                    <StatelessCheckbox
                      label={i.title}
                      onChange={(isChecked) => onItemValueChanged(isChecked, i.id, i.selectedType)}
                      isChecked={
                        i.selectedType === selectionTypes.selected ||
                        i.selectedType === selectionTypes.indeterminate
                      }
                      className={classnames(
                        styles.labelListItem,
                        i.selectedType === selectionTypes.indeterminate
                          ? styles.indeterminate
                          : null,
                      )}
                    />
                  ) : (
                    <StatelessCheckbox
                      label={i.title}
                      onChange={(isChecked) => onItemValueChanged(isChecked, i.id)}
                      isChecked={i.isSelected}
                      className={styles.labelListItem}
                    />
                  )}

                  {i.canDelete ? (
                    <i
                      className={classnames("icon icon-cross", styles.deleteItem)}
                      data-qa="delete-label"
                      onClick={() =>
                        onDeleteItem({
                          labelId: i.id,
                          isUsed: i.isUsed,
                        })
                      }
                    />
                  ) : null}
                </div>
              )
            })}
          {this.props.children}
          {!items.length && !hideEmptyHint && (
            <span className={styles.empty}>{i18n("Delivering.Labels:NoLablesAvailable")}</span>
          )}
        </div>
      </div>
    )
  }
}

export default LabelsFilterItems
